import React from 'react';
import { Device } from '../../lib/types';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

interface RecallDeviceModalProps {
  open: boolean;
  onClose: () => void;
  device: Device | null;
  onRecall: (deviceId: string) => void;
}

export default function RecallDeviceModal({ open, onClose, device, onRecall }: RecallDeviceModalProps) {
  if (!device) {
    return null;
  }

  const currentDevice = device;
  const isFoster = currentDevice.holderType === 'foster';
  const title = isFoster ? 'Recall device' : 'Remove pet';

  const message = isFoster
    ? `Recall ${currentDevice.id}${currentDevice.petName ? ` (${currentDevice.petName})` : ''} from ${
        currentDevice.holderName
      }? The foster will be notified to return the device.`
    : `Remove ${currentDevice.petName || 'this pet'} from ${
        currentDevice.id
      }? The device will remain in your rescue\u2019s inventory.`;

  function handleConfirm() {
    onRecall(currentDevice.id);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>{title}</ModalTitle>
      <ModalSubtitle>{message}</ModalSubtitle>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          {isFoster ? 'Recall Device' : 'Remove Pet'}
        </Button>
      </ModalActions>
    </Modal>
  );
}
